document.addEventListener('DOMContentLoaded', () => {

    const heroSwiper = new Swiper('.hero-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
        fadeEffect: {
			crossFade: true,
		},
		effect: "fade",
        pagination: {
			el: ".hero-dots",
			clickable: true,
		},
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        }
	});

    const sliderSwiper = new Swiper('.slider-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
        navigation: {
			nextEl: ".slider-next",
			prevEl: ".slider-prev",
		},
        on: {
            slideChange: function () {
                const currentSlide = this.realIndex + 1;
                document.querySelector("[data-num]").innerHTML = currentSlide;
            }
        }
	});

    const reviewsSwiper = new Swiper('.reviews-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
        fadeEffect: {
			crossFade: true,
		},
		effect: "fade",
        navigation: {
			nextEl: ".reviews-next",
			prevEl: ".reviews-prev",
		},
	});

    const gallerySwiper = new Swiper('.gallery-swiper', {
		slidesPerView: "auto",
		loop: true,
		speed: 600,
        navigation: {
			nextEl: ".gallery-next",
			prevEl: ".gallery-prev",
		},
		autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
		breakpoints: {
			300: {
				slidesPerView: 1.2,
				centeredSlides: true,
				spaceBetween: 15
			},
			600: {
				slidesPerView: "auto",
				centeredSlides: false,
				spaceBetween: 20
			}
        }
	});

	const carouselImgSwiper = new Swiper('.carousel-img-swiper', {
		slidesPerView: 1,
		effect: "fade",
		speed: 800,
		centeredSlides: true,
		fadeEffect: {
			"crossFade": true
		},
		allowTouchMove: false,
	});

	const carouselTextSwiper = new Swiper('.carousel-text-swiper', {
		centeredSlides: true,
		loop: true,
		slideToClickedSlide: true,
		speed: 800,
		on: {
			slideChange: function () {
				let slideIndex = this.realIndex;
				carouselImgSwiper.slideTo(slideIndex);
			}
		},
		breakpoints: {
			300: {
				slidesPerView: 1
			},
			1260: {
				slidesPerView: 2.5,
				spaceBetween: 30
			}
		},
		navigation: {
			nextEl: ".carousel-next",
			prevEl: ".carousel-prev",
		}
	});

	const imagesSwiper = new Swiper('.images-slider', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
        fadeEffect: {
			crossFade: true,
		},
		effect: "fade",
        navigation: {
			nextEl: ".images-next",
			prevEl: ".images-prev",
		},
	});
});